import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

import { CircleCheckmarkIcon, Modal, tokens } from '@treams/treams-ui';

import ThankYouModal from '../../../../kakapo-ui-kit/components/modals/ThankYouModal';

export default function FeedbackRequestThankYou(props: {
	returnURL: string;
	numberOfRecipients: number;
}) {
	const { t } = useTranslation();
	const history = useHistory();

	return (
		<Modal>
			<Modal.Header title={t('common.feedback.feedbackSent')} />

			<Modal.Contents>
				<ThankYouModal
					title={t('common.feedback.feedbackRequestSentToNumberOfRecipients', {
						numberOfRecipients: props.numberOfRecipients,
					})}
					buttonTitle={
						props.returnURL.includes('competencies')
							? t('common.feedback.backToCompetencies')
							: t('common.feedback.backToFeedbackOverview')
					}
					icon={
						<CircleCheckmarkIcon
							size={56}
							solid
							color={tokens.success.icon}
							aria-hidden
						/>
					}
					onClick={() => history.push(props.returnURL)}
				/>
			</Modal.Contents>
		</Modal>
	);
}
